import styles from './TemplateActivate.module.css'
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import React, {useRef, useState} from "react";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
import errorLineItem from "../../FormTemplate/ErrorLineItem/ErrorLineItem";

interface TemplateCtnInt
{
    sourceCtn:string
    targetCtn:string
    validSourceCtn:boolean
    validTargetCtn:boolean
    found:boolean
    data:any
}

export default function TemplateActivate()
{
    const errorLineRef = useRef<ErrorLineItemRef>(null)
    const [templateCtn, setTemplateCtn] = useState<TemplateCtnInt>({
        sourceCtn:"",
        targetCtn:"",
        found: false,
        validSourceCtn: false,
        validTargetCtn: false,
        data:{}
    })
    const [sourceCtn,setSourceCtn] = useState("")
    const [targetCtn,setTargetCtn] = useState("")
    return(
        <div className={styles.mainCont}>
            <MainFormTemplate title={"Активация по шаблону"} maxWidth={"500px"}>
                <div className={"row"}>
                    <div className={"col-sm-12"}>
                        <InputItem
                            val={sourceCtn}
                            mode={"ei"}
                            info={"Исходный номер"}
                            placeHolder={"XXXXXXXXXX"}
                            type={"numeric"}
                            title={"Исходный номер"}
                            regExp={/^((\+7)|(8)|(^))9[0-9]{9}$/ui}
                            onChange={(e)=> {
                                if(e?.match(/^((\+7)|(8)|(^))9[0-9]{9}$/ui))
                                {
                                    const p = e?.match(/[0-9]{10}$/ui)
                                    setTemplateCtn({...templateCtn, sourceCtn: p[0], validSourceCtn: true})
                                    setSourceCtn(`+7${p[0]}`)
                                    return

                                }
                                setSourceCtn( e)
                            }}
                        ></InputItem>
                    </div>



                </div>
                <div className={styles.actCont} style={{maxHeight:"40px"}}>

                    <div className={styles.btnCont}>
                        <button type="button" className="btn btn-secondary "
                                disabled={!templateCtn?.validSourceCtn}
                                //onClick={(e)=>handleSendRecall()}
                        >Найти</button>
                    </div>
                </div>


                <div className={"row"}>
                    <div className={"col-sm-12"}>
                        <InputItem
                            val={targetCtn}
                            mode={"ei"}
                            info={"Целевой номер"}
                            placeHolder={"XXXXXXXXXX"}
                            type={"numeric"}
                            title={"Целевой номер"}
                            regExp={/^((\+7)|(8)|(^))9[0-9]{9}$/ui}
                            onChange={(e)=> {
                                if(e?.match(/^((\+7)|(8)|(^))9[0-9]{9}$/ui))
                                {
                                    const p = e?.match(/[0-9]{10}$/ui)
                                    setTemplateCtn({...templateCtn, targetCtn: p[0],validTargetCtn: true})
                                    setTargetCtn(`+7${p[0]}`)
                                    return

                                }
                                setTargetCtn( e)
                            }}
                        ></InputItem>
                    </div>
                    <div className={styles.actCont} style={{maxHeight:"40px"}}>

                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    disabled={!templateCtn?.validTargetCtn}
                                //onClick={(e)=>handleSendRecall()}
                            >Активировать</button>
                        </div>
                    </div>




                </div>

                <div className={styles.errCont}>
                    <ErrorLineItem ref={errorLineRef}></ErrorLineItem>
                </div>


            </MainFormTemplate>
        </div>
    )
}